var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"Form",attrs:{"show-legend":""}},[_c('CidadaoDocumentos',{attrs:{"data-atual":_vm.form.cidadao.dataAtual,"form":_vm.form.cidadao.documentos,"model":_vm.model.cidadao}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }